<template>
    <div id="main-register-page">
        <div id="loading-screen-page" v-show="stepNumber == 1">
            <div class="container mt-4 pr-4 pl-4 pb-1">
                <h3 class="font-weight-normal mb-4">สมัครสมาชิก</h3>
                <label for="registerAs">สมัครในนาม</label>
                <div class="row">
                    <div class="col pr-2">
                        <div class="form-group radio-card">
                            <input id="registerAsPersonal" v-validate="'required'" type="radio" name="registerAs" value="personal" v-model="registerAs" />
                            <label class="card shadow" for="registerAsPersonal">
                                <div class="card-body text-center text-secondary"><img class="icon-56" src="/goobank_assets/assets/icons/personal.png" />
                                    <p class="h6 mt-2 mb-0">บุคคลธรรมดา</p>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div class="col pl-2">
                        <div class="form-group radio-card">
                            <input id="registerAsJuristicPerson" v-validate="'required'" type="radio" name="registerAs" value="juristic_person" v-model="registerAs" />
                            <label class="card shadow" for="registerAsJuristicPerson">
                                <div class="card-body text-center text-secondary"><img class="icon-56" src="/goobank_assets/assets/icons/juristic-person.png" />
                                    <p class="h6 mt-2 mb-0">นิติบุคคล</p>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="form-group form-goobank" v-if="this.registerAs == 'personal'">
                    <select id="name-title" class="form-control" v-model="firstname_partial_title">
                        <option value="นาย">นาย</option>
                        <option value="นาง">นาง</option>
                        <option value="นางสาว">นางสาว</option>
                    </select>
                    <label for="name-title">คำนำหน้าชื่อ</label>
                    <div class="invalid-feedback">กรอกข้อมูลให้ครบถ้วน</div>
                </div>
                <div class="form-group form-goobank">
                    <input ref="firstname" id="firstname" v-validate="'required'" class="form-control" maxlength="50"
                    :class="{ 'is-valid': (fields.firstname && fields.firstname.dirty) && !errors.has('firstname'), 'is-invalid': errors.has('firstname') }"
                    name="firstname" type="text" v-model="firstname" />
                    <label v-if="this.registerAs == 'personal'" for="name">ชื่อ</label>
                    <label v-else for="name">ชื่อบริษัท/ห้างหุ้นส่วน</label>
                    <div class="invalid-feedback">กรอกข้อมูลให้ครบถ้วน</div>
                </div>
                <div class="form-group form-goobank" v-if="this.registerAs == 'personal'">
                    <input ref="lastname" id="lastname" v-validate="'required'" class="form-control" maxlength="50"
                    :class="{ 'is-valid': (fields.lastname && fields.lastname.dirty) && !errors.has('lastname'), 'is-invalid': errors.has('lastname') }"
                    name="lastname" type="text" v-model="lastname" />
                    <label for="name">นามสกุล</label>
                    <div class="invalid-feedback">กรอกข้อมูลให้ครบถ้วน</div>
                </div>

                <div class="form-group form-goobank" v-if="this.registerAs == 'personal'">
                    <label for="birthDateInput" style="order:0">วันเกิด</label>
                    <v-date-picker v-model="selectedBirthDate" locale="th" buddhist :popover="{ placement: 'bottom', visibility: 'click' }">
                        <input ref="birthDateInput" id="birthDateInput" name="birthDateInput" class="form-control" :value="birthDateDisplay" placeholder="กรุณาเลือกวันเกิด" @keydown.prevent="" 
                        v-validate="{ required: true, birth_date_more_than_twenty: true }" :class="{ 'is-invalid': birthDateError }"
                        />
                    </v-date-picker>
                    <div v-show="birthDateError" class="invalid-feedback" style="display:block">จำเป็นต้องกรอกและต้องมีอายุ 20 ปีบริบูรณ์</div>
                </div>

                <div class="form-group form-goobank">
                    <input class="form-control" name="telephone" type="text"
                    v-validate="{ required: true, regex: /^\d{10}$/, phone_exists: true }" maxlength="10"
                    :class="{ 'is-valid': (fields.telephone && fields.telephone.dirty) && !errors.has('telephone'), 'is-invalid': errors.has('telephone') }" v-model="telephone" placeholder="xxxxxxxxxx" />
                    <label for="tel">เบอร์โทรศัพท์</label>

                    <div class="invalid-feedback">
                        <span v-if="errors.firstByRule('telephone', 'phone_exists')">เบอร์โทรซ้ำ</span>
                        <span v-else>กรอกข้อมูลให้ครบถ้วน</span>
                    </div>
                </div>
                <div class="form-group form-goobank d-none">
                    <select class="form-control" name="memberType" v-validate="'required'" :class="{ 'is-valid': (fields.memberType && fields.memberType.dirty) && !errors.has('memberType'), 'is-invalid': errors.has('memberType') }" v-model="memberType">
                        <option value="borrower">ผู้ขอกู้</option>
                        <option value="lender">ผู้ให้กู้</option>
                    </select>
                    <label for="type">ประเภทสมาชิก</label>
                    <div class="invalid-feedback">กรอกข้อมูลให้ครบถ้วน</div>
                </div>
            </div>

            <div class="container mt-4 pr-4 pl-4 pb-1">
                <div class="row">
                    <div class="col">
                        <div class="custom-control custom-checkbox" @click="openAgreement()">
                            <input class="custom-control-input d-none" :class="{ 'is-invalid': errors.has('tosAgreement') }"  v-validate="'required'" id="tosAgreement" name="tosAgreement" type="checkbox" v-model="tosAgreement" onclick="event.stopPropagation();" />
                            <label class="custom-control-label" for="tosAgreement">ฉันยอมรับเงื่อนไขการใช้งานและนโยบายบริษัท</label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="custom-control custom-checkbox">
                            <input class="custom-control-input d-none" :class="{ 'is-invalid': errors.has('feeAgreement') }" v-validate="'required'" id="feeAgreement" name="feeAgreement" type="checkbox" v-model="feeAgreement" onclick="event.stopPropagation();" />
                            <label class="custom-control-label" for="feeAgreement">ฉันตกลงยินยอมชำระค่าสมัครสมาชิก 100 บาท</label>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col">
                        <div class="bank-info-card">
                            <div class="bank-info-title">ข้อมูลบัญชีสำหรับชำระเงิน</div>
                            <div class="bank-info-row">
                                <span class="bank-info-label">ธนาคาร</span>
                                <span class="bank-info-value">ธนาคารกสิกรไทย</span>
                            </div>
                            <div class="bank-info-row">
                                <span class="bank-info-label">เลขบัญชี</span>
                                <span class="bank-info-value font-weight-bold">110-3-66411-6</span>
                            </div>
                            <div class="bank-info-row">
                                <span class="bank-info-label">ชื่อบัญชี</span>
                                <span class="bank-info-value">บจก.บีเค รีพอร์ต ออนไลน์</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col"><a class="btn btn-primary btn-lg btn-block" href="#" @click="changeForm(2)">ยืนยันการสมัคร</a></div>
                </div>
            </div>
        </div>

        <div v-show="stepNumber == 2">
             <div class="container mt-4 pr-4 pl-4 pt-5">
                <otp-block-input v-if="stepNumber == 2" v-model="code" @requestNewOTP="sendOTP()"></otp-block-input>
                <p style="display:none;">{{code}}</p>
                <div class="row pt-4" v-if="isWrongOTP">
                    <div class="col number-bullet-xl-width-flex">
                        <div class="number-bullet-xl rounded-circle d-flex align-items-center justify-content-center bg-danger-dimmed">
                            <p class="h3 font-weight-normal m-0 text-danger">!</p>
                        </div>
                    </div>
                    <div class="col pl-0 d-flex align-items-center">
                        <p class="text-danger m-0">รหัส OTP ของคุณไม่ถูกต้อง</p>
                    </div>
                </div>
                <div class="mt-5 pb-2">
                    <button :disabled="code.length !== 6" @click="checkOTP()" class="btn btn-primary btn-lg btn-block">ยืนยันตัวตน</button>
                    <button @click="changeForm(1)" class="btn btn-light btn-lg btn-block">ย้อนกลับ</button>
                </div>
            </div>

            <!-- UNUSED BLOCK BUT FIXED BY FLEX SEAL(TM) -->
            <div class="container mt-4 pr-4 pl-4 pt-5" style="display: none;">
                <div class="pt-5">
                    <h3 class="font-weight-normal text-center">ยืนยันตัวตน</h3>
                    <p class="text-center">กรอกรหัส OTP 6 หลักจาก SMS<br/>ในเบอร์โทรศัพท์ที่คุณได้ลงทะเบียนไว้</p>
                </div>
                <div class="pt-2 d-flex justify-content-center">
                    <div class="pin-input-group">
                        <input ref="txt_otp1" id="txt_otp1" class="form-control" type="tel" v-model="otp1" @keyup="checkDigit($event, 'otp1')" @focus="focusOtpBox($event)" />
                        <input class="form-control" type="tel" v-model="otp2" @keyup="checkDigit($event, 'otp2')" @focus="focusOtpBox($event)" />
                        <input class="form-control" type="tel" v-model="otp3" @keyup="checkDigit($event, 'otp3')" @focus="focusOtpBox($event)" />
                        <input class="form-control" type="tel" v-model="otp4" @keyup="checkDigit($event, 'otp4')" @focus="focusOtpBox($event)"/>
                        <input class="form-control" type="tel" v-model="otp5" @keyup="checkDigit($event, 'otp5')" @focus="focusOtpBox($event)"/>
                        <input class="form-control" type="tel" v-model="otp6" @keyup="checkDigit($event, 'otp6')" @focus="focusOtpBox($event)"/>
                    </div>
                </div>
                <div class="pt-5 pb-3">
                    <p class="text-center font-weight-light">ไม่ได้รับข้อความ &nbsp;<a href="#" @click="sendOTP()"><u>ส่งรหัสใหม่</u></a></p>
                </div>
                <div class="mt-5 pt-5 pb-2">
                    <!-- <a class="btn btn-primary btn-lg btn-block" href="#" @click="changeForm(4)">ยืนยันตัวตน</a> -->
                    <a class="btn btn-primary btn-lg btn-block" href="#" @click="checkOTP()">ยืนยันตัวตน</a>
                    <a class="btn btn-light btn-lg btn-block" href="#" @click="changeForm(1)">ย้อนกลับ</a>
                </div>
            </div>
            <!-- END OF UNUSED BLOCK -->
        </div>

        <div v-show="stepNumber == 3">
            <div class="container mt-4 pr-4 pl-4">
                <h3 class="font-weight-normal">กรอกรายละเอียด</h3>
                <p>สวัสดีคุณ <b>{{ firstname }}</b> ทาง Goobank รบกวนขอรายละเอียดเพิ่มเติมในการออกเอกสารสัญญากับทาง Goobank กรุณากรอกข้อมูลให้ถูกต้องตามความจริง</p>
                <h6 v-if="this.registerAs == 'personal'" class="mt-4 mb-3">ที่อยู่ตามบัตรประชาชน</h6>
                <h6 v-else class="mt-4 mb-3">ที่อยู่ตามเอกสาร</h6>
                <form>
                    <div v-if="this.registerAs == 'personal'" class="row">
                        <div class="col-12">
                            <div class="form-group form-goobank">
                                <input ref="citizenID" id="citizenID" class="form-control" name="citizenID" type="text" v-model="citizenID" maxlength="13"
                                v-validate="{ required: true, citizen_id_exists: true }" :class="{ 'is-valid': (fields.citizenID && fields.citizenID.dirty) && !errors.has('citizenID'), 'is-invalid': errors.has('citizenID') }" />
                                <label for="citizenID">เลขบัตรประชาชน</label>

                                <div class="invalid-feedback">
                                    <span v-if="errors.firstByRule('citizenID', 'citizen_id_exists')">เลขบัตรประชาชนซ้ำ</span>
                                    <span v-else>กรอกข้อมูลให้ครบถ้วน</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="row">
                        <div class="col-6">
                            <div class="form-group form-goobank">
                                <input ref="citizenID" id="citizenID" class="form-control" name="citizenID" type="text" v-model="citizenID" maxlength="13"
                                v-validate="{ required: true, citizen_id_exists: true }" :class="{ 'is-valid': (fields.citizenID && fields.citizenID.dirty) && !errors.has('citizenID'), 'is-invalid': errors.has('citizenID') }" />
                                <label for="citizenID">เลขประจำตัวผู้เสียภาษี</label>

                                <div class="invalid-feedback">
                                    <span v-if="errors.firstByRule('citizenID', 'citizen_id_exists')">เลขประจำตัวผู้เสียภาษีซ้ำ</span>
                                    <span v-else>กรอกข้อมูลให้ครบถ้วน</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group form-goobank">
                                <label for="birthDateInput" style="order:0">วันที่จัดตั้งบริษัท</label>
                                <v-date-picker v-model="selectedBirthDate" locale="th" buddhist :popover="{ placement: 'bottom', visibility: 'click' }">
                                    <input ref="birthDateInput" id="birthDateInput" name="birthDateInput" class="form-control" :value="birthDateDisplay" placeholder="กรุณาเลือกจัดตั้งบริษัท" @keydown.prevent="" />
                                </v-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group form-goobank">
                                <input class="form-control" v-validate="'required'" name="addressNo" v-model="addressNo" type="text" maxlength="20"
                                :class="{ 'is-valid': (fields.addressNo && fields.addressNo.dirty) && !errors.has('addressNo'), 'is-invalid': errors.has('addressNo') }" />
                                <label v-if="this.registerAs == 'personal'" for="addressNo">บ้านเลขที่</label>
                                <label v-else for="addressNo">ที่อยู่บริษัท</label>
                                <div class="invalid-feedback">กรอกข้อมูลให้ครบถ้วน</div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group form-goobank">
                                <input class="form-control" v-validate="'required'" name="addressBuilding" v-model="addressBuilding" type="text" maxlength="50" />
                                <label for="addressBuilding">อาคาร</label>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group form-goobank">
                                <input class="form-control" v-validate="'required'" name="addressMoo" v-model="addressMoo" type="text" maxlength="50" />
                                <label for="addressMoo">หมู่</label>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group form-goobank">
                                <input class="form-control" v-validate="'required'" name="addressSoi" v-model="addressSoi" type="text" maxlength="50" />
                                <label for="addressSoi">ซอย</label>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group form-goobank">
                                <input class="form-control" name="addressRoad" v-model="addressRoad" type="text" maxlength="50"
                                :class="{ 'is-valid': (fields.addressRoad && fields.addressRoad.dirty) && !errors.has('addressRoad'), 'is-invalid': errors.has('addressRoad') }" />
                                <label for="addressRoad">ถนน</label>
                                <div class="invalid-feedback">กรอกข้อมูลให้ครบถ้วน</div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="p-2 mb-3" style="position: relative;">
                            <div class="form-group form-goobank">
                                <label for="district_manual_name" style="webkit-order:0; order:0;">แขวง / ตำบล</label>
                                <input id="district_manual_name" class="form-control" v-validate="'required'" name="district_manual_name" v-model="district_manual_name" type="text"
                                :class="{ 'is-valid': (fields.district_manual_name && fields.district_manual_name.dirty) && !errors.has('district_manual_name'), 'is-invalid': errors.has('district_manual_name') }" />
                                <div class="invalid-feedback">กรอกข้อมูลให้ครบถ้วน</div>
                            </div>
                            <div class="form-group form-goobank">
                                <label for="amphur_manual_name" style="webkit-order:0; order:0;">เขต / อำเภอ</label>
                                <input id="amphur_manual_name" class="form-control" v-validate="'required'" name="amphur_manual_name" v-model="amphur_manual_name" type="text"
                                :class="{ 'is-valid': (fields.amphur_manual_name && fields.amphur_manual_name.dirty) && !errors.has('amphur_manual_name'), 'is-invalid': errors.has('amphur_manual_name') }" />
                                <div class="invalid-feedback">กรอกข้อมูลให้ครบถ้วน</div>
                            </div>
                            <div class="form-group form-goobank">
                                <label for="province_manual_name" style="webkit-order:0; order:0;">จังหวัด</label>
                                <input id="province_manual_name" class="form-control" v-validate="'required'" name="province_manual_name" v-model="province_manual_name" type="text"
                                :class="{ 'is-valid': (fields.province_manual_name && fields.province_manual_name.dirty) && !errors.has('province_manual_name'), 'is-invalid': errors.has('province_manual_name') }" />
                                <div class="invalid-feedback">กรอกข้อมูลให้ครบถ้วน</div>
                            </div>
                    </div>
                    
                    <div class="form-group form-goobank">
                        <label for="zipcode" style="webkit-order:0; order:0;">รหัสไปรษณีย์</label>
                        <input type="text" id="zipcode" class="form-control" name="zipcode" v-model="zipcode" v-validate="'required'" maxlength="6"
                        :class="{ 'is-valid': (fields.zipcode && fields.zipcode.dirty) && !errors.has('zipcode'), 'is-invalid': errors.has('zipcode') }" />
                        <div class="invalid-feedback">กรอกข้อมูลให้ครบถ้วน</div>
                    </div>
                    <div class="form-group form-goobank">
                        <label class="ele-label" style="webkit-order:0; order:0;">ชื่อธนาคาร</label>
                        <select class="form-control ele-select" name="bankName" v-model="bankName" v-validate="'required'"
                        :class="{ 'is-valid': (fields.bankName && fields.bankName.dirty) && !errors.has('bankName'), 'is-invalid': errors.has('bankName') }" >
                            <option value="" disabled>เลือกธนาคารในการทำธุรกรรม</option>
                            <option v-for="(itm, idx) in listBank" :key="idx"
                            :value="itm.short_name" v-text="itm.name"></option>
                        </select>
                    </div>
                    <div class="form-group form-goobank">
                        <label for="bank-account" style="webkit-order:0; order:0;">เลขบัญชี</label>
                        <input type="text" id="bank-account" name="bankAccount" class="form-control" maxlength="12"
                        v-model="bankAccount" v-validate="'required'" @keypress="isNumberKey($event)"
                        :class="{ 'is-valid': (fields.bankAccount && fields.bankAccount.dirty) && !errors.has('bankAccount'), 'is-invalid': errors.has('bankAccount') }" />
                    </div>
                    <a class="btn btn-primary btn-lg btn-block mt-5 mb-1" href="#" @click="changeForm(4)">ยืนยันข้อมูล</a>
                    <a class="btn btn-light btn-lg btn-block" href="#" @click="changeForm(1)">ย้อนกลับ</a>
                </form>
            </div>
        </div>

        <div id="step-v-3-1-page" v-show="stepNumber == 4">
            <div class="container mt-4 pr-4 pl-4">
                <h3 class="font-weight-normal">รูปถ่ายแนบการสมัคร</h3>
                <p>เพื่อความปลอดภัยในการทำธุรกรรมจากทางเรา จำเป็นต้องใช้รูปถ่ายเพื่อยืนยันตัวตนที่แท้จริงของคุณ</p>

                <div class="card shadow-lg p-3 mb-3">
                    <div class="row">
                        <div class="col profile-image-width-flex"><img class="icon-56" src="/goobank_assets/assets/icons/new-image@2x.png" /></div>
                        <div class="col pl-0 d-flex flex-column justify-content-center">
                            <p v-if="this.registerAs == 'personal'" class="h6 m-0">บัตรประชาชนตัวจริง</p>
                            <p v-else class="h6 m-0">บัตรประชาชน (ผู้กระทำการแทน)</p>
                            <p class="text-secondary m-0">ตัวอย่างรูปถ่าย</p>
                            <div class="el-avatar-loading">
                                <img src="/goobank_assets/assets/default-citizen-id-card.png" v-show="!isShowCitizenIDCard" />
                                <img :src="imageSrcCitizenIDCard" v-show="isShowCitizenIDCard">
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col text-right">
                            <button class="btn btn-outline-secondary btn-close rounded-circle shadow-none opacity-60" v-show="isShowCitizenIDCard" @click="resetImage('CitizenIDCard')"><span aria-hidden="true">&times;</span></button>
                            <label class="btn btn-primary rounded-pill m-0" :class="{'disabled': isUploading}">
                                <template v-if="isUploading">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                </template>
                                <template v-else>อัพโหลดรูป</template>
                                <input type="file" ref="fileIdCard" name="image_citizen_id_card" id="image_citizen_id_card" :disabled="isUploading" @change="previewFiles('CitizenIDCard')" accept="image/x-png,image/jpeg" style="display:none;">
                            </label>
                        </div>
                    </div>
                </div>
                <div class="card shadow-lg p-3 mb-3">
                    <div class="row">
                        <div class="col profile-image-width-flex"><img class="icon-56" src="/goobank_assets/assets/icons/new-image@2x.png" /></div>
                        <div class="col pl-0 d-flex flex-column justify-content-center">
                            <p v-if="this.registerAs == 'personal'" class="h6 m-0">สมุดบัญชีเงินฝาก</p>
                            <p v-else class="h6 m-0">สมุดบัญชีเงินฝากบริษัท</p>
                            <p class="text-secondary m-0">ตัวอย่างรูปถ่าย</p>
                            <div class="el-avatar-loading">
                                <img src="/goobank_assets/assets/default-book-bank.png" v-show="!isShowBookBank" />
                                <img :src="imageSrcBookBank" v-show="isShowBookBank">
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col text-right">
                            <button class="btn btn-outline-secondary btn-close rounded-circle shadow-none opacity-60" v-show="isShowBookBank" @click="resetImage('BookBank')"><span aria-hidden="true">&times;</span></button>
                            <label class="btn btn-primary rounded-pill m-0" :class="{'disabled': isUploading}">
                                <template v-if="isUploading">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                </template>
                                <template v-else>อัพโหลดรูป</template>
                                <input type="file" ref="fileBookbank" name="image_book_bank" id="image_book_bank" :disabled="isUploading" @change="previewFiles('BookBank')" accept="image/x-png,image/jpeg" style="display:none;">
                            </label>
                        </div>
                    </div>
                </div>
                <div class="card shadow-lg p-3 mb-3">
                    <div class="row">
                        <div class="col profile-image-width-flex"><img class="icon-56" src="/goobank_assets/assets/icons/new-image@2x.png" /></div>
                        <div class="col pl-0 d-flex flex-column justify-content-center">
                            <p v-if="this.registerAs == 'personal'" class="h6 m-0">รูปตนเองคู่บัตรประชาชน</p>
                            <p v-else class="h6 m-0">รูปตนเองคู่บัตรประชาชน (ผู้กระทำการแทน)</p>
                            <p class="text-secondary m-0">ตัวอย่างรูปถ่าย</p>
                            <div class="el-avatar-loading">
                                <img src="/goobank_assets/assets/default-selfie-with-id-card.png" v-show="!isShowSelfieWithIDCard" />
                                <img :src="imageSrcSelfieWithIDCard" v-show="isShowSelfieWithIDCard">
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col text-right">
                            <button class="btn btn-outline-secondary btn-close rounded-circle shadow-none opacity-60" v-show="isShowSelfieWithIDCard" @click="resetImage('SelfieWithIDCard')"><span aria-hidden="true">&times;</span></button>
                            <label class="btn btn-primary rounded-pill m-0" :class="{'disabled': isUploading}">
                                <template v-if="isUploading">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                </template>
                                <template v-else>อัพโหลดรูป</template>
                                <input type="file" ref="fileAvatar" name="image_selfie_with_id_card" id="image_selfie_with_id_card" :disabled="isUploading" @change="previewFiles('SelfieWithIDCard')" accept="image/x-png,image/jpeg" style="display:none;">
                            </label>
                        </div>
                    </div>
                </div>

                <div class="card shadow-lg p-3 mb-3">
                    <div class="row">
                        <div class="col profile-image-width-flex"><img class="icon-56" src="/goobank_assets/assets/icons/new-image@2x.png" /></div>
                        <div class="col pl-0 d-flex flex-column justify-content-center">
                            <p class="h6 m-0">รูปถ่ายสลิปค่าสมัคร 100 บาท</p>
                            <p class="text-secondary m-0">ตัวอย่างรูปถ่าย</p>
                            <div class="el-avatar-loading">
                                <img src="/goobank_assets/assets/default-bank-slip.png" v-show="!isShowBankSlip" />
                                <img :src="imageSrcBankSlip" v-show="isShowBankSlip">
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col text-right">
                            <button class="btn btn-outline-secondary btn-close rounded-circle shadow-none opacity-60" v-show="isShowBankSlip" @click="resetImage('BankSlip')"><span aria-hidden="true">&times;</span></button>
                            <label class="btn btn-primary rounded-pill m-0" :class="{'disabled': isUploading}">
                                <template v-if="isUploading">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                </template>
                                <template v-else>อัพโหลดรูป</template>
                                <input type="file" ref="fileAvatar" name="image_bank_slip" id="image_bank_slip" :disabled="isUploading" @change="previewFiles('BankSlip')" accept="image/x-png,image/jpeg" style="display:none;">
                            </label>
                        </div>
                    </div>
                </div>

                <div class="mt-4 pb-5">
                    <a class="btn btn-primary btn-lg btn-block" href="#" @click="createUser()">ยืนยันรูปถ่าย</a>
                    <a class="btn btn-light btn-lg btn-block" href="#" @click="changeForm(3)">ย้อนกลับ</a><!-- กลับไป Form 2 ข้ามหน้า OTP -->
                </div>
            </div>
        </div>

        <div id="step-v-3-2-page" v-show="stepNumber == 5">
            <div class="container mt-4 pr-4 pl-4">
                <h3 class="font-weight-normal">เอกสารแนบการสมัคร (กรณีเป็นนิติบุคคล)</h3>
                <p>เพื่อความปลอดภัยในการทำธุรกรรมจากทางเรา จำเป็นต้องใช้รูปถ่ายเพื่อยืนยันตัวตนที่แท้จริงของคุณ</p>
                <div class="card shadow-lg p-3 mb-3">
                    <div class="row">
                        <div class="col profile-image-width-flex"><img class="icon-56" src="/goobank_assets/assets/icons/new-image@2x.png" /></div>
                        <div class="col pl-0 d-flex flex-column justify-content-center">
                            <p class="h6 m-0">สำเนาหนังสือรับรอง</p>
                            <p class="text-secondary m-0">อัปโหลดได้ทั้งรูปภาพหรือ PDF</p>
                            <div class="el-avatar-loading">
                                <img src="/goobank_assets/assets/default-pdf-uploaded.png" v-show="isShowApplicationForCertificate" />
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col text-right">
                            <button class="btn btn-outline-secondary btn-close rounded-circle shadow-none opacity-60" v-show="isShowApplicationForCertificate"  @click="resetPDF('ApplicationForCertificate')"><span aria-hidden="true">&times;</span></button>
                            <label class="btn btn-primary rounded-pill m-0" :class="{'disabled': isUploading}">
                                <template v-if="isUploading">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                </template>
                                <template v-else>อัพโหลดไฟล์</template>
                                <input type="file" ref="fileCorpCert" name="image_application_for_certificate" id="image_application_for_certificate" :disabled="isUploading" @change="previewDocumentFiles('ApplicationForCertificate')" accept="image/png,image/jpeg,application/pdf" style="display:none;">
                            </label>
                        </div>
                    </div>
                </div>
                <div class="card shadow-lg p-3 mb-3">
                    <div class="row">
                        <div class="col profile-image-width-flex"><img class="icon-56" src="/goobank_assets/assets/icons/new-image@2x.png" /></div>
                        <div class="col pl-0 d-flex flex-column justify-content-center">
                            <p class="h6 m-0">สำเนาบัตรประชาชนกรรมการ</p>
                            <p class="text-secondary m-0">อัปโหลดได้ทั้งรูปภาพหรือ PDF</p>
                            <div class="el-avatar-loading">
                                <img src="/goobank_assets/assets/default-pdf-uploaded.png" v-show="isShowDocumentToAppointJuristicPerson" />
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col text-right">
                            <button class="btn btn-outline-secondary btn-close rounded-circle shadow-none opacity-60" v-show="isShowDocumentToAppointJuristicPerson" @click="resetPDF('DocumentToAppointJuristicPerson')"><span aria-hidden="true">&times;</span></button>
                            <label class="btn btn-primary rounded-pill m-0" :class="{'disabled': isUploading}">
                                <template v-if="isUploading">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                </template>
                                <template v-else>อัพโหลดไฟล์</template>
                                <input type="file" ref="fileDocCorp" name="image_document_to_appoint_juristic_person" id="image_document_to_appoint_juristic_person" :disabled="isUploading" @change="previewDocumentFiles('DocumentToAppointJuristicPerson')" accept="image/png,image/jpeg,application/pdf" style="display:none;">
                            </label>
                        </div>
                    </div>
                </div>
                <div class="mt-4 pb-5">
                    <!-- <a class="btn btn-primary btn-lg btn-block" href="#" @click="changeForm(6)">ยืนยันรูปถ่าย</a> -->
                    <a class="btn btn-primary btn-lg btn-block" href="#" @click="createUser()">ยืนยันไฟล์เอกสาร</a>
                    <a class="btn btn-light btn-lg btn-block" href="#" @click="changeForm(3)">ย้อนกลับ</a>
                </div>
            </div>
        </div>

        <div id="step-register-complete-page" v-show="stepNumber == 6">
            <div class="container mt-4 pr-4 pl-4">
                <div class="card shadow">
                    <div class="card-body">
                        <div class="img-container text-center p-2"><img class="w-100" src="/goobank_assets/assets/icons/img-register-complete.png" /></div>
                        <div class="p-4 text-center">
                            <h3 class="font-weight-normal">สมัครเสร็จสมบูรณ์</h3>
                            <p>เจ้าหน้าที่จะตรวจข้อมูลและเอกสารของท่านภายใน 24 ชั่วโมง และจะแจ้งผลพร้อมรหัสเข้าใช้ผ่านทาง SMS</p>
                        </div>
                        <div class="mt-2 pt-2 pb-4 pl-3 pr-3 mb-4">
                            <!-- <a class="btn btn-primary btn-block btn-lg" href="#" @click="changeForm(1)">กลับสู่หน้าหลัก</a> -->
                            <a class="btn btn-primary btn-block btn-lg" href="#" @click="gotoLoginPage()">ทำการ Login</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <ModalComponent v-if="isShowModal">
                <!-- <h4 slot="header" class="mt-4"></h4> -->
                <div slot="body">
                    <div v-html="docs.regis"></div>
                </div>
                <div slot="footer">

                    <button class="btn btn-primary" @click="acceptAgreement()">ยอมรับ</button>
                    <button class="btn btn-outline-primary" @click="acceptAgreement(false)">ไม่ยอมรับ</button>
                </div>
            </ModalComponent>
        </div>
    </div>

</template>


<script>
    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    import { Validator } from 'vee-validate';

    import ShareFunction from '../share-function';
    import ModalComponent from '../components/ModalComponent';
    import dateFormat from '../components/utils/date.js';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    import docs from '../docs';

    Vue.use(VeeValidate);
    Vue.use(Loading);
    export default {
        components: {
            ModalComponent,
            Loading,
        },
        props: {
            baseUrl: '',
        },
        watch: {
            selectedBirthDate: function (birthDateValue) {
                let absoluteYears = moment().diff(moment(birthDateValue), 'years');
                if(absoluteYears >= 20) {
                    this.birthDateError = false;
                } else {
                    this.birthDateError = true;
                }
            }
        },
        data: function () {
            return {
                docs,

                stepNumber: 1,

                firstname_partial_title: 'นาย',
                firstname_partial_name: '',

                selectedBirthDate: null,

                firstname: '',
                lastname: '',
                telephone: '',
                memberType: 'lender',
                registerAs: 'personal',

                tosAgreement: false,
                feeAgreement: false,

                citizenID: '',
                addressNo: '',
                addressBuilding: '',
                addressMoo: '',
                addressSoi: '',
                addressRoad: '',
                district_manual_name: '',
                amphur_manual_name: '',
                province_manual_name: '',
                zipcode: '',

                otp1: '',
                otp2: '',
                otp3: '',
                otp4: '',
                otp5: '',
                otp6: '',

                otp_id: '',
                code: '',

                register_token: null,
                otpErrorMsg: '',
                isWrongOTP: false,

                initImageSrc: '',
                imageSrcCitizenIDCard: '',
                imageSrcBookBank: '',
                imageSrcSelfieWithIDCard: '',
                imageSrcBankSlip: '',
                imageSrcApplicationForCertificate: '',
                imageSrcDocumentToAppointJuristicPerson: '',

                isUploading: false,
                listBank: [],
                bankName: '',
                bankAccount: '',
                isShowModal: false,
                hasAlreadyPhone: false,
                loader: null,

                birthDateError: false
            }
        },
        mounted() {
            // document.getElementById('firstname').focus();
        },
        created() {
            // this.stepNumber = 4;
            this.loadBankList();
            this.customValidate();
        },
        computed: {
            birthDateDisplay () {
                if(this.selectedBirthDate) {
                    return dateFormat.thaidate(this.selectedBirthDate);
                } else {
                    return '';
                }
            },
            isShowCitizenIDCard() {
                return this.imageSrcCitizenIDCard != this.initImageSrc;
            },
            isShowBookBank() {
                return this.imageSrcBookBank != this.initImageSrc;
            },
            isShowSelfieWithIDCard() {
                return this.imageSrcSelfieWithIDCard != this.initImageSrc;
            },
            isShowBankSlip() {
                return this.imageSrcBankSlip != this.initImageSrc;
            },
            isShowApplicationForCertificate() {
                return this.imageSrcApplicationForCertificate != this.initImageSrc;
            },
            isShowDocumentToAppointJuristicPerson() {
                return this.imageSrcDocumentToAppointJuristicPerson != this.initImageSrc;
            }
        },
        methods: {
            showLoading() {
                this.loader = this.$loading.show({
                  canCancel: false,
                });
            },
            hideLoading() {
                if (this.loader != null) {
                  this.loader.hide();
                }
            },
            customValidate() {
                let timeValidate = null;
                Validator.extend('phone_exists', {
                    getMessage: field => 'phone exists.',
                    validate: async value => {
                        clearTimeout(timeValidate);
                        await new Promise(resolve => {
                            timeValidate = setTimeout(() => {
                                resolve();
                            }, 500);
                        });
                        let isExists = false;
                        if (timeValidate) {
                            isExists = await axios.post(`${this.baseUrl}/api/register/check-existing-phone`,
                                { telephone: this.telephone }
                            ).then(({ data }) => {
                                if (data && data.success === false) {
                                    return true;
                                } else {
                                    return false;
                                }
                            });
                        }
                        return !isExists;
                    }
                });

                Validator.extend('citizen_id_exists', {
                    getMessage: field => 'citizen_id exists.',
                    validate: async value => {
                        clearTimeout(timeValidate);
                        await new Promise(resolve => {
                            timeValidate = setTimeout(() => {
                                resolve();
                            }, 500);
                        });
                        let isExists = false;
                        if (timeValidate) {
                            isExists = await axios.post(`${this.baseUrl}/api/register/check-existing-citizen-id`,
                                { citizen_id: this.citizenID }
                            ).then(({ data }) => {
                                if (data && data.success === false) {
                                    console.log("Citizen Return True");
                                    return true;
                                } else {
                                    console.log("Citizen Return False");
                                    return false;
                                }
                            });
                        }

                        console.log("Citizen is Exist is : "+ isExists);
                        // return true;
                        return !isExists;
                    }
                });

                Validator.extend('birth_date_more_than_twenty', {
                    getMessage: field => 'more than twenty years old',
                    validate: () => {
                        const vm = this;
                        let selectedBirthDate = vm.selectedBirthDate;

                        let absoluteYears = moment().diff(moment(selectedBirthDate), 'years');

                        if(absoluteYears >= 20) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                });
            },
            gotoLoginPage() {
                window.location = '/index/login';
            },
            checkDigit(e, evalString) {
                if (e.target.value != '') {
                    if (e.target.value.length > 1) {
                        this[evalString] = e.target.value = e.target.value[e.target.value.length - 1];
                    }
                    if (e.target.nextElementSibling != null) {
                        e.target.nextElementSibling.focus();
                    }
                }
            },
            focusOtpBox(event) {
                event.target.setSelectionRange(0, event.target.value.length)
            },
            async changeForm(forceStep = null) {
                const vm = this;
                if(forceStep == 1) {
                    this.stepNumber = 1;
                } else if(forceStep == 2) {
                    let task;
                    if(this.registerAs == 'personal') {
                        task = Promise.all([
                            this.$validator.validate('firstname'),
                            this.$validator.validate('lastname'),
                            this.$validator.validate('telephone'),
                            this.$validator.validate('memberType'),
                            this.$validator.validate('registerAs'),
                            this.$validator.validate('birthDateInput'),
                            this.$validator.validate('tosAgreement'),
                            this.$validator.validate('feeAgreement'),
                        ]);

                        if(this.selectedBirthDate == null) {
                            this.birthDateError = true;
                        }
                    } else {
                        task = Promise.all([
                            this.$validator.validate('firstname'),
                            this.$validator.validate('telephone'),
                            this.$validator.validate('memberType'),
                            this.$validator.validate('registerAs'),
                            this.$validator.validate('tosAgreement'),
                            this.$validator.validate('feeAgreement'),
                        ]);
                    }

                    const areValid = (await task).every(isValid => isValid);

                    if(areValid) {
                        // Force สร้าง User ขึ้นทันที
                        // this.createUser();
                        // สามารถ Comment ตรงนี้กลับเข้ามา แล้ว comment บรรทัดด้านล่างออก เพื่อทำการ Debug โปรแกรมโดยไม่มี SMS OTP ได้

                        // ต้องใช้ฟังก์ชัน nextTick ของ Vue.js ด้วย เพราะว่า v-show ทำการ update DOM ไม่ทัน
                        this.stepNumber = 2;
                        this.$nextTick(() => {
                            document.getElementById('txt_otp1').focus();
                        });
                        this.sendOTP();
                    } else {
                        this.stepNumber = 1;
                    }
                } else if(forceStep == 3) {
                    this.stepNumber = 3;

                    this.$nextTick(() => {
                        document.getElementById('citizenID').focus();
                    });
                } else if (forceStep == 4) {
                    const task = Promise.all([
                        // ของหน้าแรก ก็ต้อง validate
                        this.$validator.validate('firstname'),
                        this.$validator.validate('telephone'),
                        this.$validator.validate('memberType'),
                        this.$validator.validate('registerAs'),
                        this.$validator.validate('tosAgreement'),

                        // validate
                        this.$validator.validate('addressNo'),
                        // this.$validator.validate('addressRoad'), // ไม่บังคับกรอก
                        this.$validator.validate('district_manual_name'),
                        this.$validator.validate('amphur_manual_name'),
                        this.$validator.validate('province_manual_name'),
                        this.$validator.validate('zipcode'),
                        this.$validator.validate('bankName'),
                        this.$validator.validate('bankAccount')
                    ]);

                    // const areValid = (await task).every(isValid => isValid);

                    const areValid = (await task).every(isValid => {
                        return isValid;
                    });
                    
                    // แยกมาเช็คอีกทีก่อน Submit
                    this.$validator.validate('citizenID').then((result) => {
                        
                        if(areValid && result == true) {
                            // ต้องใช้ฟังก์ชัน nextTick ของ Vue.js ด้วย เพราะว่า v-show ทำการ update DOM ไม่ทัน
                            if (vm.registerAs == 'personal' || (vm.registerAs == 'juristic_person' && vm.stepNumber == 3)) {
                                vm.stepNumber = 4;
                            } else {
                                vm.stepNumber = 5;
                            }
                        } else {
                            this.stepNumber = 3;
                        }

                    });

                    
                } else {
                    this.stepNumber = forceStep;
                }
            },
            sendOTP() {
                // return;
                let vm = this;
                $.post( '/api/v1/sendOTP', {
                    telephone: vm.telephone,
                    register_token: vm.register_token,
                }, "json")
                .done( function(data) {

                    if (data.success && data.otpId) {
                        vm.otpErrorMsg = '';
                        vm.otp_id = data.otpId;
                    } else {
                        vm.otpErrorMsg = 'OTP API Error โปรดแจ้งผู้ดูแลระบบ';
                    }

                    if (vm.otpErrorMsg !== '') {
                        setTimeout(() => {
                            vm.otpErrorMsg = '';
                        }, 5500);
                    }
                })
                .fail( function(xhr, textStatus, errorThrown) {
                    console.log("Fail");
                    alert(xhr.responseText.message);
                });
            },
            checkOTP() {
                // this.stepNumber = 3;
                // return;
                let vm = this;
                // this.code = this.otp1 + this.otp2 + this.otp3 + this.otp4 + this.otp5 + this.otp6;
                if (/^([0-9]{6})$/.test(this.code) === true) {
                    $.post( "/api/v1/validateOTP", {
                        otp_id: vm.otp_id,
                        code: vm.code
                    }, "json")
                    .done( function(data) {
                        if(data.success) {
                            // vm.createUser(); // ทำการ Create Member เลยทันที
                            vm.stepNumber = 3;
                        } else {
                            vm.isWrongOTP = true;

                            setTimeout(() => {
                                vm.isWrongOTP = false;
                            }, 5500);
                        }
                    })
                    .fail( function(xhr, textStatus, errorThrown) {
                        console.log('xhr.responseText.message', xhr.responseText.message);
                    });
                } else {
                    vm.isWrongOTP = true;
                    vm.code = ''
                    setTimeout(() => {
                        vm.isWrongOTP = false;
                    }, 5500);
                    return false;
                }
            },
            validateImagePersonal() {
                var fileIdCard = $("#image_citizen_id_card")[0].files.length;
                var fileBookbank = $("#image_book_bank")[0].files.length;
                var fileSelfie = $("#image_selfie_with_id_card")[0].files.length;
                var fileBankSlip = $("#image_bank_slip")[0].files.length;
                if(fileIdCard === 0 || fileBookbank === 0 || fileSelfie === 0 || fileBankSlip === 0){
                    return false;
                }
                return true;
            },
            validateImageJuristic() {
                var fileCert = $("#image_application_for_certificate")[0].files.length;
                var fileJuristic = $("#image_document_to_appoint_juristic_person")[0].files.length;
                if(fileCert === 0 || fileJuristic === 0){
                    return false;
                }
                return true;
            },
            createUser() {
                if (this.stepNumber >= 4) {
                    if (!this.validateImagePersonal()) {
                        alert('กรุณาอัพโหลดรูปถ่ายให้ครบถ้วย');
                        return;
                    }
                }
                if (this.stepNumber == 5) {
                    if (!this.validateImageJuristic()) {
                        alert('กรุณาอัพโหลดรูปถ่าย(นิติบุคคุล)ให้ครบถ้วย');
                        return;
                    }
                }
                if (this.registerAs == 'juristic_person' && this.stepNumber == 4) {
                    this.changeForm(5);
                    return;
                }
                const vm = this;
                this.showLoading();
                axios.defaults.headers.common["X-CSRF-TOKEN"] = document
                    .querySelector('meta[name="csrf-token"]')
                    .getAttribute("content");

                var formData = new FormData();

                formData.append('partial_title', vm.firstname_partial_title);
                formData.append('firstname', vm.firstname);
                formData.append('lastname', vm.lastname);
                formData.append('telephone', vm.telephone);
                formData.append('member_type', vm.memberType);
                formData.append('register_as', vm.registerAs);
                formData.append('citizen_id', vm.citizenID);
                formData.append('birth_date', moment(vm.selectedBirthDate).format("YYYY-MM-DD"));
                formData.append('address_no', vm.addressNo);
                formData.append('address_building', vm.addressBuilding);
                formData.append('address_moo', vm.addressMoo);
                formData.append('address_soi', vm.addressSoi);
                formData.append('address_road', vm.addressRoad);
                formData.append('district_manual_name', vm.district_manual_name);
                formData.append('amphur_manual_name', vm.amphur_manual_name);
                formData.append('province_manual_name', vm.province_manual_name);
                formData.append('zipcode', vm.zipcode);
                formData.append('bank_name', vm.bankName);
                formData.append('bank_account', vm.bankAccount);

                const fileInputSrcCitizenIDCard = document.querySelector('#image_citizen_id_card');
                if (fileInputSrcCitizenIDCard && fileInputSrcCitizenIDCard.files.length > 0) {
                    formData.append('image_citizen_id_card', fileInputSrcCitizenIDCard.files[0]);
                }

                const fileInputSrcBookBank = document.querySelector('#image_book_bank');
                if (fileInputSrcBookBank && fileInputSrcBookBank.files.length > 0) {
                    formData.append('image_book_bank', fileInputSrcBookBank.files[0]);
                }

                const fileInputSrcSelfieWithIDCard = document.querySelector('#image_selfie_with_id_card');
                if (fileInputSrcSelfieWithIDCard && fileInputSrcSelfieWithIDCard.files.length > 0) {
                    formData.append('image_selfie_with_id_card', fileInputSrcSelfieWithIDCard.files[0]);
                }

                const fileInputSrcBankSlip = document.querySelector('#image_bank_slip');
                if (fileInputSrcBankSlip && fileInputSrcBankSlip.files.length > 0) {
                    formData.append('image_bank_slip', fileInputSrcBankSlip.files[0]);
                }

                const fileInputSrcApplicationForCertificate = document.querySelector('#image_application_for_certificate');
                if (fileInputSrcApplicationForCertificate && fileInputSrcApplicationForCertificate.files.length > 0) {
                    formData.append('image_application_for_certificate', fileInputSrcApplicationForCertificate.files[0]);
                }

                const fileInputSrcDocumentToAppointJuristicPerson = document.querySelector('#image_document_to_appoint_juristic_person');
                if (fileInputSrcDocumentToAppointJuristicPerson && fileInputSrcDocumentToAppointJuristicPerson.files.length > 0) {
                    formData.append('image_document_to_appoint_juristic_person', fileInputSrcDocumentToAppointJuristicPerson.files[0]);
                }

                axios.post('/api/register/createuser',
                    formData
                ).then(({ data }) => {
                    if (data != null) {
                        if (!data.success) {
                            alert("Something Error!");
                            if (data.status == 'user_exists' || data.status == 'member_exists') {
                                alert(data.message);
                            } else if (data.status == 'member_change') {
                                vm.telephone = data.telephone;
                                alert(data.message);
                            } else if (data.status == 'validate') {
                                const msg = JSON.parse(data.message);
                                let exitFor = false;
                                Object.keys(msg).forEach(item => {
                                    if (exitFor == false) {
                                        exitFor = true;
                                        alert(msg[item]);
                                    }
                                });
                            } else if (data.message) {
                                alert(data.message);
                            }
                        } else {
                            // Go to completed page.
                            vm.stepNumber = 6;
                        }
                    }
                }).catch(err => {

                }).then(() => {
                    this.hideLoading();
                });
                return false;
            },
            previewFiles(imageName) {
                var vm = this;
                var files = event.target.files;
                if (files && files[0]) {
                    if (files[0].type != 'image/png' && files[0].type != 'image/jpeg') {
                        // window.alertbox('only jpg/jpeg file types are allowed', 'warning');
                        alert('only jpg/jpeg file types are allowed', 'warning');
                        this.resetImage();
                        return;
                    }
                    var fileSize = files[0].size;
                    var mbMaxSize = 30 * (1024 * 1024);  // 30 MB
                    if (fileSize > mbMaxSize) {
                        // window.alertbox('Maximum allowed 30MB for uploaded files', 'warning');
                        alert('Maximum allowed 30MB for uploaded files', 'warning');
                        this.resetImage();
                        return;
                    }
                    var reader = new FileReader();
                    vm.isUploading = true;
                    reader.onload = function(e) {
                        if(imageName == 'CitizenIDCard') {
                            vm.imageSrcCitizenIDCard = e.target.result;
                        } else if(imageName == 'BookBank') {
                            vm.imageSrcBookBank = e.target.result;
                        } else if(imageName == 'SelfieWithIDCard') {
                            vm.imageSrcSelfieWithIDCard = e.target.result;
                        } else if(imageName == 'BankSlip') {
                            vm.imageSrcBankSlip = e.target.result;
                        }
                    }
                    reader.onloadend = function(e) {
                        setTimeout(() => {
                            vm.isUploading = false;
                        }, 500);
                    }
                    reader.readAsDataURL(files[0]);
                }
            },
            resetImage(imageName) {
                if(imageName == 'CitizenIDCard') {
                    this.$refs.fileIdCard.value = '';
                    this.imageSrcCitizenIDCard = this.initImageSrc;
                } else if(imageName == 'BookBank') {
                    this.$refs.fileBookbank.value = '';
                    this.imageSrcBookBank = this.initImageSrc;
                } else if(imageName == 'SelfieWithIDCard') {
                    this.$refs.fileAvatar.value = '';
                    this.imageSrcSelfieWithIDCard = this.initImageSrc;
                } else if(imageName == 'BankSlip') {
                    this.$refs.fileAvatar.value = '';
                    this.imageSrcBankSlip = this.initImageSrc;
                }
            },
            previewPDFs(imageName) {
                var vm = this;
                var files = event.target.files;
                if (files && files[0]) {
                    if (files[0].type != 'application/pdf') {
                        // window.alertbox('only jpg/jpeg file types are allowed', 'warning');
                        alert('only pdf file types are allowed', 'warning');
                        this.resetImage();
                        return;
                    }
                    var fileSize = files[0].size;
                    var mbMaxSize = 30 * (1024 * 1024);  // 30 MB
                    if (fileSize > mbMaxSize) {
                        // window.alertbox('Maximum allowed 30MB for uploaded files', 'warning');
                        alert('Maximum allowed 30MB for uploaded files', 'warning');
                        this.resetPDF();
                        return;
                    }
                    var reader = new FileReader();
                    vm.isUploading = true;
                    reader.onload = function(e) {
                        if(imageName == 'ApplicationForCertificate') {
                            vm.imageSrcApplicationForCertificate = e.target.result;
                        } else if(imageName == 'DocumentToAppointJuristicPerson') {
                            vm.imageSrcDocumentToAppointJuristicPerson = e.target.result;
                        }
                    }
                    reader.onloadend = function(e) {
                        setTimeout(() => {
                            vm.isUploading = false;
                        }, 500);
                    }
                    reader.readAsDataURL(files[0]);
                }
            },
            previewDocumentFiles(imageName) {
                var vm = this;
                var files = event.target.files;
                if (files && files[0]) {
                    var isPdf = files[0].type == 'application/pdf';
                    var isImage = files[0].type == 'image/png' || files[0].type == 'image/jpeg';
                    if (!isPdf && !isImage) {
                        alert('only jpg/jpeg/png/pdf file types are allowed', 'warning');
                        this.resetPDF(imageName);
                        return;
                    }
                    var fileSize = files[0].size;
                    var mbMaxSize = 30 * (1024 * 1024);  // 30 MB
                    if (fileSize > mbMaxSize) {
                        alert('Maximum allowed 30MB for uploaded files', 'warning');
                        this.resetPDF(imageName);
                        return;
                    }
                    vm.isUploading = true;

                    if (isPdf) {
                        if (imageName == 'ApplicationForCertificate') {
                            vm.imageSrcApplicationForCertificate = '/goobank_assets/assets/default-pdf-uploaded.png';
                        } else if (imageName == 'DocumentToAppointJuristicPerson') {
                            vm.imageSrcDocumentToAppointJuristicPerson = '/goobank_assets/assets/default-pdf-uploaded.png';
                        }
                        setTimeout(() => {
                            vm.isUploading = false;
                        }, 500);
                        return;
                    }

                    var reader = new FileReader();
                    reader.onload = function(e) {
                        if (imageName == 'ApplicationForCertificate') {
                            vm.imageSrcApplicationForCertificate = e.target.result;
                        } else if (imageName == 'DocumentToAppointJuristicPerson') {
                            vm.imageSrcDocumentToAppointJuristicPerson = e.target.result;
                        }
                    }
                    reader.onloadend = function() {
                        setTimeout(() => {
                            vm.isUploading = false;
                        }, 500);
                    }
                    reader.readAsDataURL(files[0]);
                }
            },
            resetPDF(imageName) {
                if(imageName == 'ApplicationForCertificate') {
                    this.$refs.fileCorpCert.value = '';
                    this.imageSrcApplicationForCertificate = this.initImageSrc;
                } else if(imageName == 'DocumentToAppointJuristicPerson') {
                    this.$refs.fileDocCorp.value = '';
                    this.imageSrcDocumentToAppointJuristicPerson = this.initImageSrc;
                }
            },
            loadBankList() {
                axios.get(`${window.BASE_URL}/index/api/list-bank`)
                .then(({ data }) => {
                    if (data != null && data.data) {
                        this.listBank = data.data;
                    }
                });
            },
            isNumberKey(evt) {
                return ShareFunction.isNumberKey(evt);
            },
            openAgreement() {
                this.isShowModal = true;
            },
            acceptAgreement(isAccept = true) {
                this.isShowModal = false;
                this.tosAgreement = isAccept;
            }
        },
    }
</script>

<style lang="scss" scoped>
#main-register-page .el-avatar-loading, #main-register-page .el-avatar-loading img {
    width: 100%;
}
.ele-select {
    background: none;
    outline: none;
    color: #46464680; // from bootstrap
}
.bank-info-card {
    border: 1px solid #e0d6f7;
    border-radius: 10px;
    padding: 12px 16px;
    background: #faf8ff;
}

.bank-info-title {
    font-size: 0.8em;
    font-weight: 600;
    color: #6c2bdc;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin-bottom: 10px;
}

.bank-info-row {
    display: flex;
    align-items: baseline;
    margin-bottom: 5px;
    font-size: 0.9em;

    &:last-child {
        margin-bottom: 0;
    }
}

.bank-info-label {
    color: #888;
    white-space: nowrap;
    min-width: 80px;
    flex-shrink: 0;
}

.bank-info-value {
    color: #333;
}

.ele-form-select {
    border-bottom: 1px solid #ccc;
    .ele-box-select {
        border-bottom: none;
    }
    .ele-label {
        margin: 0 0 2px;
        color: #777;
    }
}

</style>
